export const alloysPartnersAlloysId = "/alloys/partners/:alloys_id";
